import { useTranslation } from 'react-i18next';

export default function CompanySection() {
  const { t } = useTranslation();

  const infoItems = [
    { label: t('company.name'), value: t('company.nameValue') },
    { label: t('company.ceo'), value: t('company.ceoValue') },
    { label: t('company.address'), value: t('company.addressValue') },
    { label: t('company.capital'), value: t('company.capitalValue') },
    { label: t('company.business'), value: t('company.businessValue') },
  ];

  return (
    <section id="company" className="py-16 md:py-24 bg-white">
      <div className="w-full px-4 sm:px-6 lg:px-10 xl:px-16">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-4xl font-bold text-trust-navy tracking-tight font-jp">
            {t('company.title')}
          </h2>
          <div className="mt-3 w-12 h-0.5 bg-warm-accent mx-auto" />
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="border border-gray-200 rounded-lg overflow-hidden">
            {infoItems.map((item, index) => (
              <div
                key={index}
                className={`flex flex-col sm:flex-row ${
                  index !== infoItems.length - 1 ? 'border-b border-gray-100' : ''
                }`}
              >
                <div className="sm:w-1/3 bg-surface-light px-5 py-4 sm:py-5">
                  <span className="text-sm font-medium text-gray-600 font-jp">
                    {item.label}
                  </span>
                </div>
                <div className="sm:w-2/3 px-5 py-4 sm:py-5">
                  <span className="text-sm md:text-base text-gray-900 font-jp">
                    {item.value || '\u00A0'}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}